import { render, staticRenderFns } from "./TaxPaymentAccount.vue?vue&type=template&id=90fc8aba&scoped=true&"
import script from "./TaxPaymentAccount.vue?vue&type=script&lang=js&"
export * from "./TaxPaymentAccount.vue?vue&type=script&lang=js&"
import style0 from "./TaxPaymentAccount.vue?vue&type=style&index=0&id=90fc8aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fc8aba",
  null
  
)

component.options.__file = "TaxPaymentAccount.vue"
export default component.exports